import { IPersistedCatalogueFilters } from '../../types';

export const CATALOGUE_FILTERS_PERSIST = 'CATALOGUE_FILTERS_PERSIST';
export const CATALOGUE_FILTERS_CLEAR = 'CATALOGUE_FILTERS_CLEAR';

export const persistCatalogueFilters = (filters: IPersistedCatalogueFilters) => {
  return {
    type: CATALOGUE_FILTERS_PERSIST,
    payload: filters,
  };
};

export const clearCatalogueFilters = () => {
  return {
    type: CATALOGUE_FILTERS_CLEAR,
  };
};
